import { combineReducers } from 'redux'
import loginReducer from './loginReducer'
import userReducer from './userReducer'
import customerReducer from './customerReducer'

export default combineReducers({
  loginReducer,
  userReducer,
  customerReducer
})
